import {AddSchema, Field, MGLClass} from "mobx-graphlink";
import {name_general} from "../../../Utils/General/SharedPatterns.js";

@MGLClass({table: "maps"})
export class DMap {
	constructor(data: Partial<DMap>) { Object.assign(this, data); }

	@Field({$ref: "UUID"})
	id: string;

	@Field({$ref: "UUID"})
	creator: string;

	@Field({type: "number"})
	createdAt: number;

	@Field({type: "string", pattern: name_general})
	name: string;
}